// Mirrors composer-backend's unified channel schema (ENG-1855/ENG-1857):
// app/channels/schema.py (ChannelDefinition, FieldSpec, FieldConstraints)
// and app/schemas/channel_overrides.py (ChannelRead).

export type FieldType = 'string' | 'number' | 'bool' | 'object';
export type MetadataFieldType = 'string' | 'number' | 'bool';

export enum ContentFormat {
    text = 'text',
    externalReference = 'external_reference',
}

export enum SchemaSource {
    inline = 'inline',
    external = 'external',
}

export interface FieldConstraints {
    max_length?: number;
    min?: number;
    max?: number;
    enum?: (string | number)[];
}

export interface FieldSpec {
    key: string;
    type: FieldType;
    fields?: FieldSpec[];
    role?: string;
    required: boolean;
    default?: unknown;
    constraints?: FieldConstraints;
    supports_alternates: boolean;
}

export interface MetadataFieldSpec {
    key: string;
    type: MetadataFieldType;
    required: boolean;
    default?: unknown;
    constraints?: FieldConstraints;
    role?: string;
}

export interface ChannelDefinition {
    key: string;
    name: string;
    description?: string;
    icon?: string;
    nav_order?: number;
    content_format: ContentFormat;
    schema_source: SchemaSource;
    schema_resolver?: string;
    fields?: FieldSpec[];
    metadata_fields: MetadataFieldSpec[];
}

export interface ChannelRead {
    key: string;
    overridden: boolean;
    builtin: ChannelDefinition;
    override?: ChannelDefinition | null;
    effective: ChannelDefinition;
}

export interface ChannelOverrideCreate {
    name: string;
    description?: string;
    icon?: string;
    nav_order?: number;
    content_format?: ContentFormat;
    schema_source: SchemaSource.inline;
    fields?: FieldSpec[];
    metadata_fields?: MetadataFieldSpec[];
}

export type ChannelOverrideUpdate = Partial<ChannelOverrideCreate>;

export interface ChannelOverrideMutationResult {
    applied: boolean;
    affected_message_ids: number[];
    drafted_message_ids: number[];
    archived_message_ids: number[];
    affected_webhook_config_ids: string[];
    channel: ChannelRead | null;
}

// The raw, unconverted structure stored for a formula on an override channel
// (app/schemas/formulas.py's MessageStructure `dict` branch): a flat/nested
// dictionary of values keyed by the effective definition's field keys,
// rather than a Slate `Descendant[]` document.
export interface OverrideChannelStructure {
    version: 2;
    fields: Record<string, unknown>;
}

// Temporary pilot-rollout restriction while this feature is being validated
// with a small set of customers - remove once it's ready for general release.
export const ALLOWED_CUSTOMER_IDS_FOR_CHANNEL_OVERRIDES = [
    2544, 1001, 2547, 1250,
];
